import { useShopTime } from '@modules/Timezone/providers/ShopTimeProvider';
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase';
import { useAnalyticsParams } from '../../../../modules/AnalyticsParams/hooks/useAnalyticsParams';
import { createAnalyticsChartData } from '../../../../utils/createAnalyticsChartData';
import { extractPrimitiveValue } from '../../../../utils/extractPrimitiveValue';
import { formatChartLabel } from '../../../AnalyticsReport/hooks/utils/formartChartLabel';
const reportId = 'visitors';
export const useVisitorsReportCard = () => {
    const analyticsCardBase = useAnalyticsCardBase({ reportId });
    const { groupBy, dateRange } = useAnalyticsParams();
    const { toShopTime } = useShopTime();
    const timezonedDateRange = [
        toShopTime(dateRange.value.dates[0]),
        toShopTime(dateRange.value.dates[1]),
    ];
    const getValue = () => {
        if (!analyticsCardBase.reportData || !analyticsCardBase.activeColumn)
            return 0;
        const summaryValue = analyticsCardBase.reportData.report
            .summary[analyticsCardBase.activeColumn.key];
        const primitiveValue = extractPrimitiveValue(summaryValue);
        return typeof primitiveValue === 'number' ? primitiveValue : 0;
    };
    return {
        ...analyticsCardBase,
        type: 'lineChart',
        value: getValue(),
        data: createAnalyticsChartData({
            reportData: analyticsCardBase.reportData,
            activeSeries: analyticsCardBase.activeColumn?.key || '',
        }),
        formatXAxis: (value) => formatChartLabel({
            value,
            type: analyticsCardBase.reportDefinition?.columns[0].type || 'number',
            timezonedDateRange,
            precision: groupBy.value.value,
        }),
    };
};
